module.exports = __webpack_public_path__ + "images/pages/sns_campaign_lp/balloon-1_1e20febfb0bddf9106e2d60ac7baee41.png";